import { $axios } from '@/shared/api/axios'
import { ServerResponse } from '@/shared/types/common'

interface DolyamePayData {
	PAY_ID: string
	PAYMENT_TYPE: 'DOLYAME'
}

export const fetchDolyamePayId = async () => {
	const { data } = await $axios.get<ServerResponse<DolyamePayData>>('pay/dolyame')

	return data
}
